import React, { } from "react";
import { NewFieldStyles, NewFieldTypes, SystemTypes } from "../../Definitions";
import { colors, fonts } from "../../Styles";
import { NewInput } from "../BaseComponents";
import { TerminalDataProps } from "./_GlobalComponents/editTerminalsData";
import { EditTerminalsRow, getSelectedId, SystemProps } from "./SubComponents/editTerminalsRow";
import { useTerminalResContext } from "./_GlobalComponents/terminalReducer";

interface EditTerminalsCardProps<TSystem extends SystemTypes>extends SystemProps<TSystem> {
  data: TerminalDataProps
  mobile: boolean
}

export default function EditTerminalsCard<TSystem extends SystemTypes>({data, selected, mobile, systemType}:EditTerminalsCardProps<TSystem>) {
  const { state: termResState, dispatch: termResDispatch } = useTerminalResContext();
  const { updatedLocations } = termResState
  const selectedId = getSelectedId(systemType, selected);
  
  if (!data) return;
  
  return (
    <div
      key={`row_pen_${selectedId}`}
      style={{
        backgroundColor: colors.greyLightSecondary,
        padding: mobile ? "0px 10px" : "0px 20px",
        display: "flex",
        alignItems: "start",
        justifyContent: "center",
        flexDirection: "column",
        width: mobile ? "310px" : "333px",
        boxSizing: "border-box",
        borderRadius: "10px"
      }}
    >
      <div style={{ whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: "5px", padding: "10px 0px", ...fonts.fontSize4, ...fonts.paragraph, color: colors.greyDarkPrimary }}>
        { systemType === SystemTypes.freedaLf ? data.locationName.text : systemType === SystemTypes.freedaEsf_WalkThrough ? data.locationName.text : undefined}

        <NewInput
          key={`name_${selectedId}`}
          onChange={(e) => {
            if (systemType === SystemTypes.freedaLf) { termResDispatch({ penNames: [{ location_id: selectedId, new_name: e }]}) }
            if (systemType === SystemTypes.freedaEsf_WalkThrough) { termResDispatch({ stationNames: [{ station_id: selectedId, new_name: e}]}) }
            termResDispatch({ updatedLocations: { ...updatedLocations, [selectedId]: e !== selected.name } });
          }}
          isRequired
          placeholder={""}
          fieldOverrides={{
            fieldStyle: NewFieldStyles.greyTertiary,
            fieldType: NewFieldTypes.tertiaryField,
            fieldWidth: "100px"
          }}
          valueOverrides={{
            defaultValue: selected.name,
            valueType: "number",
            minValueNumber: 1,
            maxValueNumber: 999999
          }}
        />
      </div>
      <div style={{ gridArea: "2/1/3/4", display: "flex", flexDirection: "column", borderTop: "2px solid " + colors.greyTertiary, padding: "10px 0px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "60px 60px 100px 43px", gap: "10px"}}>
          <p style={{ ...fonts.fontSize4, ...fonts.header, color: colors.greyPrimary }}></p>
          <p style={{ ...fonts.fontSize4, ...fonts.header, color: colors.greyPrimary, padding: "0px 5px" }}>Port</p>
          <p style={{ ...fonts.fontSize4, ...fonts.header, color: colors.greyPrimary, padding: "0px 5px" }}>I/O Board</p>
          <p style={{ ...fonts.fontSize4, ...fonts.header, color: colors.greyPrimary, padding: "0px 5px" }}>On</p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          {data.terminals.map((item, index) => 
            <EditTerminalsRow
              key={index}
              item={item}
              data={data}
              selected={selected}
              systemType={systemType}
            />
          )}
        </div>
      </div>
    </div>
  )
 }
